<template>
    <div>
        <div style="width: 400px;">
            <md-card md-with-hover class="login-field" style="margin-top: 50%;">
                <md-card-media style="margin-left: 25%; margin-top: 5%; margin-bottom: -5%; width: 50%;">
                    <img src="/static/KHOR.png">
                </md-card-media>
                <md-card-header style="display: grid;" class="logo-field">
                    <div class="md-title" style="padding-left: 28px; float: left;"> Iniciar sessão </div>
                </md-card-header>
                <md-card-content class="input-values">
                    <md-field class="md-primary form-field">
                        <label>Empresa</label>
                        <md-input class="input-field" id="company" v-model="company" @change="escondeMsg" autofocus></md-input>
                    </md-field>
                    <md-field class="md-primary form-field">
                        <label>Usuário</label>
                        <md-input class="input-field" id="username" v-model="username" @change="escondeMsg"></md-input>
                    </md-field>
                    <md-field class="md-primary form-field">
                        <label>Senha</label>
                        <md-input  class="input-field" type="password" id="password" v-model="password" @change="escondeMsg" @keyup.enter.native="login"></md-input>
                    </md-field>
                    <p v-if="usuarioSenhaInvalidos" class="text-red"> {{msgErroSistema}} </p>
                    <md-button class="md-dense md-raised md-primary btn-texto-branco" @click.native="login">Log In</md-button>
                </md-card-content>
                <div class="loading-overlay md-accent" v-if="exibeSpinner">
                    <md-progress-spinner md-mode="indeterminate" :md-stroke="2"></md-progress-spinner>
                </div>
            </md-card>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'loginForm',

        methods: {
            login: function () {
                this.exibeSpinner = true;
                var _this = this
                var settings = {
                    async: true,
                    url: _this.$root.urlAPI + 'login/',
                    type: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    data: JSON.stringify({
                        'username': _this.username,
                        'password': _this.password,
                        'company': _this.company
                    })
                }
                $.ajax(settings)
                    .done(function (data) {
                        var base64Url = data.access_token.split('.')[1];
                        var base64 = base64Url.replace('-', '+').replace('_', '/');
                        var token = JSON.parse(window.atob(base64));
                        localStorage.setItem('expiration', token.exp);
                        _this.$root.expiration = token.exp;
                        localStorage.setItem('access_token', data.access_token);
                        _this.$root.accessToken = data.access_token;
                        _this.exibeSpinner = false;
                        _this.$router.push('/DashBoard');
                    })
                    .fail(function (result) {
                        _this.exibeSpinner = false;
                        var errors = JSON.parse(result.responseText);
                        _this.msgErroSistema = errors.msg;
                        _this.usuarioSenhaInvalidos = true;
                    })
            },
            escondeMsg: function () {
                this.usuarioSenhaInvalidos = false
            },            
        },

        data: () => ({
            exibeSpinner: false,
            msgErroSistema: 'Não foi possivel conectar ao Sistema, entre em contato com o Suporte!',
            msgOkSistema: '',
            username: '',
            password: '',
            company: '',
            usuarioSenhaInvalidos: false,
            src: './KHOR.png'
        })
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-progress-bar {
        margin: 24px;
    }
    .loading-overlay {
        z-index: 10;
        top: 0;
        left: 0;
        right: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue